import { Injectable } from "@angular/core";
import { TokenService } from "../auth/token.service";
import { ClientConfigurationLoader, ConfigurationLoader, LocalStorageService, LogService } from "@nts/std/utility";
import { firstValueFrom } from "rxjs";
import { VersionLoader } from "../resources/version-loader.factory";
import { TranslationLoader } from "../resources/translation-loader.factory";

@Injectable({
  providedIn: 'root'
})
export class StdInitService {

  private initialized = false;
  private initPromise: Promise<void> | null = null;

  constructor(
    private translationLoader: TranslationLoader,
    private versionLoader: VersionLoader,
    private configurationLoader: ConfigurationLoader,
    private clientConfigurationLoader: ClientConfigurationLoader,
    private localStorageService: LocalStorageService,
    private tokenService: TokenService, // Necessario per la gestione dei token
  ) { }

  async init(): Promise<void> {

    if (this.initialized) {
      return;
    }

    if (this.initPromise !== null) {
      await this.initPromise;
      return;
    }

    this.initPromise = this.doInit();

    try {
      await this.initPromise;
      this.initialized = true;
    } finally {
      this.initPromise = null;
    }
  }

  private async doInit(): Promise<void> {
    await this.localStorageService.init();
    await this.tokenService.init();

    await firstValueFrom(this.clientConfigurationLoader.getConfiguration());
    await firstValueFrom(this.configurationLoader.getConfiguration());

    await firstValueFrom(this.translationLoader.getTranslation(navigator.language));
    await firstValueFrom(this.versionLoader.getVersion());

    // Clean old cache
    if ('caches' in window) {

      const deleteCache = async (key: string) => {
        await caches.delete(key);
      };

      const deleteAllCaches = async () => {
        const keyList = await caches.keys();
        const cachesToDelete = keyList;
        LogService.log('Cancello cache di workers');
        await Promise.all(cachesToDelete.map(deleteCache));
      };
      // "ngsw:/:8950aab197ca77a01a4717c10e1197e9e4f330ea:assets:app:cache"
      // "ngsw:/:e21b140ad4a1e5370bbb03ec9a2b2c9c51fe26a7:assets:app:cache"
      const versionList = (await caches.keys()).filter(key => key.indexOf('assets:app:cache') > -1);
      if (versionList?.length > 1) {
        LogService.log('Workers trovati', versionList);
        await deleteAllCaches();
      }
    }
  }
}
